import { useSelector } from 'react-redux';

import { VStack, Heading, Text } from '@frontend/legacy-components';

import { usePreferredUnitSystem } from 'utils/measurement/hooks';

import { getDimensionalPrecision, getDisplayScale } from '../data/reducer';

type VolumeAreaWeightDisplayProps = {
  isEnabled: boolean;
  properties: {
    area?: number;
    volume?: number;
    weight?: number;
  };
};

const VolumeAreaWeightDisplay = ({
  isEnabled,
  properties,
}: VolumeAreaWeightDisplayProps) => {
  const displayScale = useSelector(getDisplayScale);
  const dimensionalPrecision = useSelector(getDimensionalPrecision);
  const { area = 0, volume = 0, weight = 0 } = properties;

  const { formatVolume, formatArea, formatWeight } = usePreferredUnitSystem();

  const volString =
    volume > 0
      ? formatVolume(volume, { decimalPoints: dimensionalPrecision })
      : '';

  const areaString =
    area > 0 ? formatArea(area, { decimalPoints: dimensionalPrecision }) : '';

  const weightString = weight
    ? formatWeight({
        weight,
        dimensionalPrecision,
        displayScale,
      })
    : '';

  if (!isEnabled) return null;
  if (!volString && !areaString && !weightString) return null;

  return (
    <VStack spacing={0} width="200px" align="end">
      <Heading color="inherit" size="md">
        File
      </Heading>
      {volString && <Text color="inherit">{`Volume: ${volString}`}</Text>}
      {areaString && <Text color="inherit">{`Area: ${areaString}`}</Text>}
      {weightString && <Text color="inherit">{`Weight: ${weightString}`}</Text>}
    </VStack>
  );
};

export default VolumeAreaWeightDisplay;
